import type { ReactNode } from 'react'
import type { DocumentAccess, AccessOption } from '../api/easeedeskSolutions'
import { SelectPicker } from '../ui/SelectPicker'

/**
 * Cine vede UN document din biblioteca - roluri si oameni anume.
 *
 * Nimic bifat = documentul mosteneste categoria (cine vede categoria il vede
 * si pe el), adica exact ce era inainte. Cu ceva bifat, il vad numai rolurile
 * si oamenii bifati - si tot numai daca vad si categoria. Serverul tine
 * regula pe fiecare usa (lista, cautarea, articolul, fisierele, tichetul);
 * aici doar se alege.
 *
 * Doua randuri cu aceeasi forma ca celelalte campuri din formular, ca sa
 * stea si in formularul orizontal (Self-Service) si in cel vertical (solutii).
 */
export function DocumentAccessPicker({ idPrefix, roles, people, value, onChange, horizontal = false }: {
  idPrefix: string
  roles: AccessOption[]
  people: AccessOption[]
  value: DocumentAccess
  onChange(next: DocumentAccess): void
  horizontal?: boolean
}) {
  const inherits = value.roles.length === 0 && value.users.length === 0
  const label = horizontal ? 'col-sm-3 control-label' : 'control-label'
  const field = (node: ReactNode) => (horizontal ? <div className="col-sm-9">{node}</div> : node)

  return (
    <>
      <div className="form-group">
        <label htmlFor={`${idPrefix}-roles`} className={label}>
          Visible to roles
        </label>
        {field(
          <SelectPicker
            id={`${idPrefix}-roles`}
            className="form-control"
            multiple
            title="Same as the category"
            options={roles.map((r) => ({ value: String(r.id), label: r.name }))}
            value={value.roles.map(String)}
            onChange={(picked) => onChange({ ...value, roles: picked.map(Number) })}
          />
        )}
      </div>
      <div className="form-group">
        <label htmlFor={`${idPrefix}-users`} className={label}>
          Visible to people
        </label>
        {field(
          <>
            <SelectPicker
              id={`${idPrefix}-users`}
              className="form-control"
              multiple
              title="Same as the category"
              options={people.map((p) => ({ value: String(p.id), label: p.name }))}
              value={value.users.map(String)}
              onChange={(picked) => onChange({ ...value, users: picked.map(Number) })}
            />
            <span className="help-block document-access-hint">
              {inherits
                ? 'Nothing picked: everybody who can see the category can see this one.'
                : 'Only the roles and people picked here can see this one - and only if they can see the category.'}
            </span>
          </>
        )}
      </div>
    </>
  )
}
